import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { webConfig } from 'webConfig';
import {
    Wrapper,
    GivelifyLogo,
    Title,
    List,
    SubmitButton,
} from './styles';
import { useMediaQuery, useTheme } from '@mui/material';
import { DesignTokens, GivelifyLabel } from '@givelify/ui';

const Activate: React.FC = () => {
    const { t } = useTranslation();
    const TRANSLATION_KEY = 'signup.activate.activated';
    const scopedTranslate = useCallback(
        (key: string) => t(`${TRANSLATION_KEY}.${key}`),
        [t],
    );

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('mobile'));

    const copy = useMemo(
        () => ({
            title: scopedTranslate('title'),
            listHeader: scopedTranslate('listHeader'),
            listItem1: scopedTranslate('listItem1'),
            listItem2: scopedTranslate('listItem2'),
            listItem3: scopedTranslate('listItem3'),
            listItem4: scopedTranslate('listItem4'),
            footerLink: scopedTranslate('footerLink'),
            submitText: scopedTranslate('submitText'),
        }),
        [scopedTranslate],
    );

    return (
        <Wrapper data-testid="activateSuccess">
            <GivelifyLogo />
            <Title
                text={copy.title}
                variant={isMobile ? 'heading2S' : 'heading2M'}
                color={DesignTokens.color.textSecondary}
            />
            <GivelifyLabel
                text={copy.listHeader}
                variant={isMobile ? 'body1' : 'heading2S'}
                color={DesignTokens.color.textSecondary}
            />
            <List>
                <li>
                    <GivelifyLabel
                        text={copy.listItem1}
                        variant={isMobile ? 'body1' : 'heading2S'}
                        color={DesignTokens.color.textSecondary}
                    />
                </li>
                <li>
                    <GivelifyLabel
                        text={copy.listItem2}
                        variant={isMobile ? 'body1' : 'heading2S'}
                        color={DesignTokens.color.textSecondary}
                    />
                </li>
                <li>
                    <GivelifyLabel
                        text={copy.listItem3}
                        variant={isMobile ? 'body1' : 'heading2S'}
                        color={DesignTokens.color.textSecondary}
                    />
                </li>
                <li>
                    <GivelifyLabel
                        text={copy.listItem4}
                        variant={isMobile ? 'body1' : 'heading2S'}
                        color={DesignTokens.color.textSecondary}
                    />
                </li>
            </List>
            <SubmitButton
                text={copy.submitText}
                variant="primary"
                size="large"
                href={webConfig.givelifySignInPageUrl}
            />
        </Wrapper>
    );
};

export default Activate;
